import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { PlatformType } from "../../../types/baseTypes";

import styles from "./Socials.module.scss";
import { CustomLink } from "@/components/CustomLink";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";

interface SocialsProps {
  platforms: PlatformType;
  headline?: string;
  showName?: boolean;
}

export const Socials = ({
  platforms,
  headline,
  showName = false,
}: SocialsProps) => {
  const { getLabel } = useGlobalContext();

  return (
    <div className={`${styles["socials-col"]}`}>
      {headline && (
        <span className="footer-headline h3 is-block">{headline}</span>
      )}
      <div
        className={
          styles.socials +
          ` ${showName === false ? styles["flow-wrap"] : ""} footer-socials`
        }
      >
        {Array.isArray(platforms) &&
          platforms.length > 0 &&
          platforms.map((social, index) => {
            if (social?.name) {
              const arialLabel = getLabel("aria_label_socials")?.replace(
                `"$title_social_network"`,
                social.name,
              );

              return (
                social.link &&
                social.show_footer && (
                  <CustomLink
                    id={`social-${index}`}
                    className={styles.social + " footer-link"}
                    target="_blank"
                    rel="noopener"
                    aria-label={arialLabel}
                    key={index}
                    href={social.link}
                  >
                    {social?.icon?.url && (
                      <CustomSVG
                        width={20}
                        height={20}
                        src={social.icon?.url || ""}
                        wrapper={"span"}
                        aria-hidden="true"
                        className="is-flex"
                      />
                    )}

                    {showName && <p className="footer-link">{social.name}</p>}
                  </CustomLink>
                )
              );
            }
          })}
      </div>
    </div>
  );
};
